import React from "react";
import Modal from "react-modal";
import {useParams} from "react-router-dom";
import Swal from "sweetalert2";
import {FaTimes} from "react-icons/fa";
import {RiSafe2Line} from "react-icons/ri";
import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik} from "formik";

import {createContainer, editOneContainer} from "../../../../../helpers/Api";
import {
  CampoSelectTipoContenedorAsync
} from "../../../../../helpers/CampoSelectTipoContenedorAsync";

const ModalAgregarContendor = ({
  modalAddContainer,
  closeAddContainerModal,
  dataOneContainer,
  naviera
}) => {

  const params = useParams();
  const token = localStorage.getItem("token");

  let initialValues = {
    tipo: (dataOneContainer === "") ? null : {value: dataOneContainer.tipo, label: dataOneContainer.tipo_descripcion},
    numero: dataOneContainer.numero || "",
    dias_libre_demora: (dataOneContainer === "")? "" : dataOneContainer.dias_libre_demora ,
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      width: "50%",
      height: "55%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      background: "linear-gradient(141.48deg, #DBFBFF -2.31%, #DBE9FF 101.54%)",
      borderRadius: "5px",
      border: "none",
      boxShadow: "0px 11px 30px 12px rgba(0, 0, 0, 0.04)",
    },
    overlay: { zIndex: 1000 },
  };

  const handlerCreateContenedor = async (values) => {
    try {
      const response = await createContainer(
        params.id,
        { tipo: values.tipo.value, numero: values.numero,
          dias_libre_demora: values.dias_libre_demora,
        }, token);
      if (response.status === 201) {
        Swal.fire({
          position: 'center-center',
          icon: 'success',
          title: 'Contenedor creado exitosamente',
          showConfirmButton: false,
          timer: 1500
        })
      setTimeout(() => {
        window.location.reload();
      }, "1500");
        closeAddContainerModal();
      }else if (response.status === 403){
        Swal.fire(
          "Oops",
          `Tu cuenta ha sido desactivada, no puedes crear contenedores`,
          "error"
        );
      }else if (response.status === 400){
        Swal.fire(
          "Oops",
          `Tu cuenta ha sido desactivada, no puedes crear contenedores`,
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Oops",
        `Ha surgido un problema al guardar los cambios: ${JSON.stringify(error.response.data)}`,
        "error"
      );
    }
  };

  const handlerEditContenedor = async (values) => {
    try {
      const response = await editOneContainer(
        params.id, dataOneContainer.id,
        {
        tipo: values.tipo.value ? values.tipo.value : dataOneContainer.tipo,
        numero: values.numero,
        dias_libre_demora: values.dias_libre_demora,
        }, token);
      if (response) {
        Swal.fire({
          position: 'center-center',
          icon: 'success',
          title: 'Contenedor creado exitosamente',
          showConfirmButton: false,
          timer: 1500
        })
      setTimeout(() => {
        window.location.reload();
      }, "1500");
        closeAddContainerModal();
      }
    } catch (error) {
      Swal.fire(
        "Oops",
        `Ha surgido un problema al guardar los cambios del contenedor. ${JSON.stringify(error.response.data)}`,
        "error"
      );
    }
  };

  return (
    <Modal
      isOpen={modalAddContainer}
      onRequestClose={closeAddContainerModal}
      style={customStyles}
      contentLabel="Example Modal"
      ariaHideApp={false}
    >
      <div className="row m-1">
        <div className="col-12  d-flex flex-row-reverse">
          <button className="btn" onClick={closeAddContainerModal}>
            <FaTimes style={{ color: "#F47777" }} />
          </button>
        </div>
      </div>
      <div className="row addContainer">
        <div className="col-12 mb-4 d-flex align-items-start">
          <RiSafe2Line size={"1.4rem"} />{" "}
          <h6 style={{ paddingLeft: "0.5rem", marginTop: "2px" }}>
            Agregar contenedor
          </h6>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            // tipo: Yup.string().required("Campo requerido"),
            // numero: Yup.string().required("Campo requerido"),
            // dias_libre_demora: Yup.string().required("Campo requerido"),
          })}
          onSubmit={(values, { resetForm }) => {
            if (dataOneContainer.id){
              handlerEditContenedor(values);
              resetForm();
            }
            else{
              handlerCreateContenedor(values);
              resetForm();
          }}
        }
        >
          {(props) => (
            <Form>
              <div className="col-12">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Número de contenedor
                </label>
                <Field
                  type="text"
                  name="numero"
                  className="form-control"
                />
                   <ErrorMessage
                  name="numero"
                  component="p"
                  className="requiredField"
                />
              </div>
              <div className="col-12 mb-4">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Tipo de contenedor
                </label>
                <CampoSelectTipoContenedorAsync
                  name={"tipo"} 
                  onChange={props.setFieldValue}
                  selectedValue={props.values.tipo}
                  naviera={naviera}
                  placeholder="Seleccione el tipo" />
                  {/* <ErrorMessage
                  name="tipo"
                  component="p"
                  className="requiredField"
                  /> */}
              </div>
              <div className="col-12">
                <label htmlFor="exampleFormControlInput1" className="form-label">
                  Días libres de demoras
                </label>
                <Field
                  type="text"
                  name="dias_libre_demora"
                  className="form-control"
                />
                   <ErrorMessage
                  name="dias_libre_demora"
                  component="p"
                  className="requiredField"
                />
              </div>
              <div className="col-12 d-flex flex-row-reverse">
                <button type="submit" className="btn btn-primary mt-4">
                   {dataOneContainer.numero ? 'Guardar cambios' : 'Crear contenedor'}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default ModalAgregarContendor;
